import { Modal, Button, Form } from "react-bootstrap";

const EditPipelineStage = ({ show, handleClose, onReopen }) => {
  const close = () => {
    handleClose && handleClose();
    onReopen && onReopen();
  };

  return (
    <Modal show={show} onHide={close} backdrop={false} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Stage</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Label>Stage Name *</Form.Label>
        <Form.Control defaultValue="Follow Up" />

        <div className="footer-actions">
          <Button variant="light" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="btn-orange">Save</Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EditPipelineStage;
